import CreatorMediaPushPage from "./CreatorMediaPushPage";

export default CreatorMediaPushPage;
